// extracted by mini-css-extract-plugin
module.exports = {"alert":"TagManagment_alert_hAj5a","createInput":"TagManagment_createInput_2L8iL","list":"TagManagment_list_2mu2b","editInput":"TagManagment_editInput_2vsTp"};